import React, { useState, useEffect } from "react";
import { useTable, useSortBy, useFilters } from "react-table";
import { Axios } from "../config";
import Navbar from "../Components/Navbar";
import { useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import "../Style/TeamStatsPage.css";

const START_YEAR = 2025;
const currentYear = new Date().getFullYear();
const yearOptions = ["All", ...Array.from({ length: currentYear - START_YEAR + 1 }, (_, i) => START_YEAR + i)];

function TeamStatsPage() {
  const [records, setRecords] = useState([]);
  const { TeamName } = useParams();
  const { Format } = useParams();
  const [TitleFormat, setTitleFormat] = useState("");
  const [TitleTeam, setTitleTeam] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [visibleColumns, setVisibleColumns] = useState({
    PlayerName: true,
    RunsScored: true,
    BallsPlayed: true,
    Fours: true,
    Sixes: true,
    GamesPlayed: true,
    NotOut: true,
    BattingAverage: true,
    BattingStrikeRate: true,
    BallsPerBoundary: true,
    OversBowled: true,
    RunsGiven: true,
    WicketsTaken: true,
    WidesBowled: true,
    BowlingEconomy: true,
    BowlingAverage: true,
    BowlingStrikeRate: true,
    CatchesTaken: true,
    RunOuts: true,
    CatchesDropped: true,
    CatchesPercentage: true,
  });
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    fetchData();
    SetTitles();
  }, [TeamName, Format, selectedYear]);

  const fetchData = () => {
    const year = selectedYear === "All" ? null : selectedYear;
    Axios.post("/GetTeamStatsData", { TeamName, Format, year })
      .then((response) => {
        setRecords(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const SetTitles = () => {
    console.log("Format:", Format);
    console.log("TeamName:", TeamName);
    if (Format === "35Overs") {
      setTitleFormat("35 Overs");
    }
    if (Format === "T20") {
      setTitleFormat("T20");
    }
    if (Format === "WeekNights") {
      setTitleFormat("WeekNights");
    }
    if (TeamName === "ShaheenGladiators") {
      setTitleTeam("Shaheen Gladiators");
    }
    if (TeamName === "ShaheenWarriors") {
      setTitleTeam("Shaheen Warriors");
    }
    if (TeamName === "ShaheenMavericks") {
      setTitleTeam("Shaheen Mavericks");
    }
    if (TeamName === "ShaheenTitans") {
      setTitleTeam("Shaheen Titans");
    }
    if (TeamName === "ShaheenKnights") {
      setTitleTeam("Shaheen Knights");
    }
    if (Format === "OverAll") {
      setTitleFormat("Records");
    }
    if (TeamName === "OverAll") {
      setTitleTeam("Overall");
    }
  };

  const customSort = (rowA, rowB, columnId, desc) => {
    let a = rowA.values[columnId];
    let b = rowB.values[columnId];

    // Handle null or undefined
    if (a === null || a === undefined) return desc ? -1 : 1;
    if (b === null || b === undefined) return desc ? 1 : -1;

    // Convert to numbers
    a = parseFloat(a);
    b = parseFloat(b);

    // Fallback in case parse fails
    if (isNaN(a) || isNaN(b)) {
      return 0;
    }

    return a > b ? 1 : a < b ? -1 : 0;
  };

  const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder={`Search...`}
      className="filterinput"
      style={{ width: "100%", padding: "4px" }}
    />
  );

  const filterGreaterThan = (rows, id, filterValue) => {
    return rows.filter((row) => row.values[id] >= filterValue);
  };

  filterGreaterThan.autoRemove = (val) => typeof val !== "number";

  const columns = React.useMemo(
    () => [
      {
        Header: "Player Name",
        accessor: "PlayerName",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "PlayerName",
      },
      {
        Header: "Runs Scored",
        accessor: "RunsScored",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "RunsScored",
      },
      {
        Header: "Balls Played",
        accessor: "BallsPlayed",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BallsPlayed",
      },
      {
        Header: "Fours",
        accessor: "Fours",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "Fours",
      },
      {
        Header: "Sixes",
        accessor: "Sixes",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "Sixes",
      },
      {
        Header: "Played",
        accessor: "GamesPlayed",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "GamesPlayed",
      },
      {
        Header: "Not out",
        accessor: "NotOut",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "NotOut",
      },
      {
        Header: "Batting Avg",
        accessor: "BattingAverage",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BattingAverage",
      },
      {
        Header: "Batting SR",
        accessor: "BattingStrikeRate",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BattingStrikeRate",
      },
      {
        Header: "Balls/Boundary",
        accessor: "BallsPerBoundary",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BallsPerBoundary",
      },
      {
        Header: "Overs",
        accessor: "OversBowled",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "OversBowled",
      },
      {
        Header: "Runs",
        accessor: "RunsGiven",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "RunsGiven",
      },
      {
        Header: "Wickets",
        accessor: "WicketsTaken",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "WicketsTaken",
      },
      {
        Header: "Wides",
        accessor: "WidesBowled",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "WidesBowled",
      },
      {
        Header: "Economy",
        accessor: "BowlingEconomy",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BowlingEconomy",
      },
      {
        Header: "Bowling Avg",
        accessor: "BowlingAverage",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BowlingAverage",
      },
      {
        Header: "Bowling SR",
        accessor: "BowlingStrikeRate",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "BowlingStrikeRate",
      },
      {
        Header: "Catches taken",
        accessor: "CatchesTaken",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "CatchesTaken",
      },
      {
        Header: "Run outs",
        accessor: "RunOuts",
        sortType: customSort,
        Filter: DefaultColumnFilter,
        className: "RunOuts",
      },
    ],
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
    allColumns,
  } = useTable(
    {
      columns,
      data: records,
      defaultColumn: { Filter: DefaultColumnFilter },
    },
    useFilters,
    useSortBy,
  );

  const handleResetFilters = () => {
    headerGroups.forEach((headerGroup) =>
      headerGroup.headers.forEach((column) => setFilter(column.id, undefined)),
    );
  };

  const handleExport = () => {
    const csvData = Papa.unparse(records);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${TitleTeam}_${TitleFormat}_Stats.csv`);
  };

  const toggleColumnVisibility = (columnId) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };

  const resetColumnVisibility = () => {
    setVisibleColumns({
      PlayerName: true,
      RunsScored: true,
      BallsPlayed: true,
      Fours: true,
      Sixes: true,
      GamesPlayed: true,
      NotOut: true,
      BattingAverage: true,
      BattingStrikeRate: true,
      BallsPerBoundary: true,
      OversBowled: true,
      RunsGiven: true,
      WicketsTaken: true,
      WidesBowled: true,
      BowlingEconomy: true,
      BowlingAverage: true,
      BowlingStrikeRate: true,
      CatchesTaken: true,
      RunOuts: true,
    });
  };

  return (
    <div>
      <Navbar />
      <div className="top20 page">
        <div className="teamName">
          <b>
            {TitleTeam} {TitleFormat}
          </b>
        </div>

        <div className="year-filter">
          {yearOptions.map((y) => (
            <button
              key={y}
              className={`filterButton${selectedYear === y ? " filterButton--active" : ""}`}
              onClick={() => setSelectedYear(y)}
            >
              {y}
            </button>
          ))}
        </div>

        <div>
          <button
            className="filterButton"
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </button>
          <button className="filterButton" onClick={handleResetFilters}>
            Reset Filters
          </button>
          <button className="filterButton" onClick={handleExport}>
            Export CSV
          </button>

          <div className="dropdown">
            <button
              className="filterButton"
              onClick={() => setDropdownVisible(!dropdownVisible)}
            >
              {dropdownVisible ? "Hide Columns" : "Show Columns"}
            </button>
            {dropdownVisible && (
              <div className="dropdown-menu">
                {allColumns.map((column) => (
                  <label key={column.id}>
                    <input
                      type="checkbox"
                      checked={visibleColumns[column.id]}
                      onChange={() => toggleColumnVisibility(column.id)}
                    />
                    {column.render("Header")}
                  </label>
                ))}
              </div>
            )}
          </div>

          <button className="filterButton" onClick={resetColumnVisibility}>
            Reset Columns
          </button>
        </div>

        <div className="table-container">
          <table className="StatsTable" {...getTableProps()}>
            <thead>
              {showFilters && (
                <tr>
                  {headerGroups[0].headers.map(
                    (column) =>
                      visibleColumns[column.id] && (
                        <th key={column.id}>
                          {column.canFilter ? column.render("Filter") : null}
                        </th>
                      ),
                  )}
                </tr>
              )}
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(
                    (column) =>
                      visibleColumns[column.id] && (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps(),
                          )}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " 🔽"
                                : " 🔼"
                              : ""}
                          </span>
                        </th>
                      ),
                  )}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    style={{
                      background: "transparent",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#00a2ff";
                      e.currentTarget.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.color = "black";
                    }}
                  >
                    {row.cells.map(
                      (cell) =>
                        visibleColumns[cell.column.id] && (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ),
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TeamStatsPage;
